import { render, staticRenderFns } from "./DSProductFields.vue?vue&type=template&id=611e8211&"
import script from "./DSProductFields.vue?vue&type=script&lang=js&"
export * from "./DSProductFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports